import type { SVGProps } from 'react';
export const IconStoresHuaweiStore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.8529 17.4392H13.5748L13.2127 16.5972L12.8529 17.4392Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9358 7H10.0643C6.35625 7 5 8.35625 5 12.0643V19.9359C5 23.6438 6.35625 25 10.0643 25H17.9333C21.6413 25 23 23.6438 23 19.9359V12.0643C23 8.35625 21.6438 7 17.9358 7ZM12.6752 17.8637L12.4611 18.3536H11.9736L13.0104 16.0016H13.4316L14.4642 18.3536H13.9636L13.7522 17.8637H12.6752ZM20.52 18.352H20.9912V16.0016H20.52V18.352ZM18.6448 17.342H19.5131V16.9137H18.6448V16.4319H19.9053V16.003H18.1737V18.3534H19.9508V17.9247H18.6448V17.342ZM16.7726 17.6198L16.2382 16.0015H15.8487L15.3144 17.6198L14.7945 16.0026H14.2863L15.1065 18.3547H15.5018L16.0369 16.8097L16.5717 18.3547H16.9706L17.7887 16.0026H17.2936L16.7726 17.6198ZM11.2543 17.3485C11.2543 17.7311 11.0643 17.9356 10.7193 17.9356C10.3723 17.9356 10.1813 17.7254 10.1813 17.3322V16.0029H9.70386V17.3485C9.70386 18.0105 10.0716 18.3901 10.7128 18.3901C11.3602 18.3901 11.7316 18.0033 11.7316 17.3291V16.0015H11.2543V17.3485ZM8.56456 16.0016H9.04184V18.3548H8.56456V17.3992H7.48625V18.3548H7.00879V16.0016H7.48625V16.9509H8.56456V16.0016ZM11.0038 10.009C11.0038 11.6611 12.348 13.0052 14 13.0052C15.652 13.0052 16.9962 11.6611 16.9962 10.009H16.5729C16.5729 11.4277 15.4188 12.5819 14 12.5819C12.5812 12.5819 11.4271 11.4277 11.4271 10.009H11.0038Z"
      fill="currentColor"
    />
  </svg>
);
